// Yotpo Review Text Replacement
(function() {
  const isProduct = document.body.classList.contains('template-product');

  function replaceReviewText() {
    try {
      const selectors = [
        '.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel',
        '.yotpo-sr-bottom-line-text',
        '[class*="yotpo"] [class*="review"]',
        '[class*="yotpo"] [class*="bottom-line"]'
      ];

      let foundElements = [];
      selectors.forEach(function(selector) {
        foundElements = foundElements.concat(Array.from(document.querySelectorAll(selector)));
      });
      foundElements = [...new Set(foundElements)];

      foundElements.forEach(function(element) {
        if (element.dataset.yotpoReplaced) return;
        const text = element.textContent || '';
        const html = element.innerHTML || '';
        const match = text.match(/(\d+)/);
        if (!match) return;

        const hasStars = html.includes('★') ||
                         html.includes('star') ||
                         html.includes('yotpo-icon-star') ||
                         html.includes('yotpo-star') ||
                         html.includes('icon-star');

        // 商品カード内（product-item）はページ種別に関わらず (N) 形式
        const isInCard = !!element.closest('.product-item__reviews-badge');
        const useCardFormat = !isProduct || isInCard;

        if (hasStars) {
          // 星を保持しつつ数字部分だけ置換
          const newHTML = useCardFormat
            ? html.replace(/(\d+)/, '($1)')
            : html.replace(/(\d+)/, '$1レビュー');
          element.innerHTML = newHTML;
        } else {
          element.textContent = useCardFormat
            ? '(' + match[1] + ')'
            : match[1] + 'レビュー';
        }
        element.dataset.yotpoReplaced = '1';
      });

    } catch (e) {
      console.error('Yotpo helper error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceReviewText);
  } else {
    replaceReviewText();
  }

  setTimeout(replaceReviewText, 1000);
  setTimeout(replaceReviewText, 2000);
  setTimeout(replaceReviewText, 3000);
  setTimeout(replaceReviewText, 5000);
})();
